<template>
    <div class="gmf-tutorial-body">
        <Slideshow v-model:slide="slide" :length="numberOfSlides" :autoslide-enabled="false">
            <div class="gmf-slideshow-slide gmf-tutorial-slide" v-for="item, idx in slides" :key="idx"
                :class="{ 'gmf-active': idx === slide }">
                <img :src="item.image" class="gmf-tutorial-slide-img" />

                <div class="gmf-center gmf-slideshow-body">
                    <h3 class="gmf-header" :key="slide">{{ item.title }}</h3>

                    <p style="white-space: pre-line" v-html="item.text">
                    </p>
                </div>
            </div>
        </Slideshow>

        <div class="gmf-center gmf-mt-4 gmf-mb-4" v-if="numberOfSlides > 1">
            <NavDots :count="numberOfSlides" :modelValue="slide" @update:modelValue="v => setSlide(v)" />

            <div>
                <button @click="setSlide(slide + 1)" class="gmf-mt-4 gmf-mb-4 gmf-btn gmf-primary">
                    {{ slide === slides.length - 1 ? t('text.done') : t('text.next') }}
                </button>

                <div>
                    <a @click="skip" href="#" class="gmf-link">{{ t('text.skip') }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.gmf-tutorial-modal {
    width: 650px;
    max-width: 100%;
    color: var(--gmf-col-black);
    /* margin-top: 40px; */
    margin-bottom: 32px;
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.gmf-tutorial-body .gmf-tutorial-slide>.gmf-tutorial-slide-img {
    width: 100%;
    max-height: 100%;
}

.gmf-tutorial-body .gmf-tutorial-slide>.gmf-slideshow-body {
    padding: var(--gmf-p-5);
}

.gmf-tutorial-slide {
    align-self: initial;
}
</style>

<script>
import state from '@/state';

import Slideshow from '@/components/Slideshow.vue';
import NavDots from '@/components/NavDots.vue';
import { ensureProfileLoaded } from '@/utils/getMyProfile';
import md from '@/utils/md';
import advancedString from '@/utils/advancedString';
import callApi from '@/utils/callApi';

const t = state.t.prefix('tutorial');

export default {
    components: { Slideshow, NavDots },

    inject: [
        'closeModal',
    ],

    data() {
        return {
            slide: 0,
        };
    },

    computed: {
        profile() {
            return state.profile;
        },
        customerName () {
            if (this.profile && this.profile.name) {
                return this.profile.name;
            }

            return state.t('comments.anonymous');
        },
        slides() {
            const slides = [];

            for (let slide = 1; slide < this.numberOfSlides + 1; slide++) {
                if (! state.merchantConfig.widgets?.tutorial?.slides?.[slide]?.image) {
                    continue;
                }

                if (!this.t(`slide_${slide}.title`) || !this.t(`slide_${slide}.text`)) {
                    continue;
                }

                let text = advancedString(this.t(`slide_${slide}.text`), {
                    name: this.customerName,
                });

                text = md(text.replaceAll('\\n', '\n'));

                slides.push({
                    image: state.merchantConfig.widgets?.tutorial?.slides[slide].image,
                    title: this.t(`slide_${slide}.title`),
                    text,
                });
            }
            
            return slides;
        },

        numberOfSlides() {
            return parseInt(state.merchantConfig.widgets?.tutorial.numberOfSlides);
        }
    },

    methods: {
        t,
        md,

        async updateTutorialState() {
            if (!this.profile) {
                return;
            }

            await callApi('POST', '/v1/client/customer-flags', {
                flags: {
                    completed_tutorial: true,
                },
            });

            if (! state.profile.flags) {
                state.profile.flags = [];
            }

            state.profile.flags.push('completed_tutorial');
        },

        setSlide(slide) {
            this.slide = Math.min(Math.max(slide, 0), this.numberOfSlides);

            if (this.slide === this.numberOfSlides) {
                this.skip();
            }
        },

        skip() {
            this.closeModal();
        }
    },

    async mounted() {
        await ensureProfileLoaded();
    },

    async unmounted() {
        await this.updateTutorialState();
    }
}
</script>